import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import {
    FormikField,
    FormikSelect,
    CountryOptions,
    RegionOptions,
} from "@qgiv/core-donor";
import { getRegions } from "@qgiv/core-js";

const ShippingFields = ({
    requirePhone = false,
    shipToFirstName = "First Name",
    shipToLastName = "Last Name",
    shipToAddressLine1 = "Address",
    shipToAddressLine2 = "Apartment, Suite, Etc.",
    shipToCityLabel = "City",
    shipToStateLabel = "State",
    shipToZipCodeLabel = "Zip Code",
    shipToCountryLabel = "Country",
}) => {
    const {
        values: { Shipping_Country },
    } = useFormikContext();
    const [regions, setRegions] = useState([]);
    useEffect(() => {
        if (Shipping_Country) {
            getRegions(Shipping_Country).then((res) => {
                setRegions(res.data);
            });
        }
    }, [Shipping_Country]);
    const stateZipRequired = Shipping_Country === "US" ? "true" : "false";
    return (
        <div className="grid">
            <div className="col col--12 col--md-6">
                <FormikField
                    id="Shipping-First-Name"
                    name="Shipping_First_Name"
                    label={shipToFirstName}
                    type="text"
                    ariaRequired="true"
                />
            </div>
            <div className="col col--12 col--md-6">
                <FormikField
                    id="Shipping-Last-Name"
                    name="Shipping_Last_Name"
                    label={shipToLastName}
                    type="text"
                    ariaRequired="true"
                />
            </div>
            <div className="col col--12">
                <FormikField
                    id="Shipping-Address"
                    name="Shipping_Address"
                    label={shipToAddressLine1}
                    type="text"
                    ariaRequired="true"
                />
            </div>

            <div className="col col--12">
                <FormikField
                    id="Shipping-Address-2"
                    name="Shipping_Address_2"
                    label={shipToAddressLine2}
                    type="text"
                    descText="Optional"
                />
            </div>
            <div className="col col--12 col--md-4">
                <FormikField
                    id="Shipping-City"
                    name="Shipping_City"
                    label={shipToCityLabel}
                    type="text"
                    ariaRequired="true"
                />
            </div>
            <div className="col col--12 col--md-4">
                <FormikSelect
                    id="Shipping-State"
                    name="Shipping_State"
                    label={shipToStateLabel}
                    type="select"
                    ariaRequired={stateZipRequired}
                >
                    <RegionOptions regions={regions} />
                </FormikSelect>
            </div>
            <div className="col col--12 col--md-4">
                <FormikField
                    id="Shipping-Zip"
                    name="Shipping_Zip"
                    label={shipToZipCodeLabel}
                    type="text"
                    ariaRequired={stateZipRequired}
                />
            </div>
            <div className="col col--12">
                <FormikSelect
                    id="Shipping-Country"
                    name="Shipping_Country"
                    label={shipToCountryLabel}
                    type="select"
                    ariaRequired="true"
                >
                    <CountryOptions />
                </FormikSelect>
            </div>

            <div className="col col--12">
                <FormikField
                    id="Shipping-Phone"
                    name="Shipping_Phone"
                    label="Phone"
                    type="tel"
                    descText={!requirePhone ? "Optional" : ""}
                    ariaRequired={!requirePhone ? "false" : "true"}
                    country={Shipping_Country || "US"}
                />
            </div>
        </div>
    );
};

ShippingFields.propTypes = {
    requirePhone: PropTypes.bool,
    shipToFirstName: PropTypes.string,
    shipToLastName: PropTypes.string,
    shipToAddressLine1: PropTypes.string,
    shipToAddressLine2: PropTypes.string,
    shipToCityLabel: PropTypes.string,
    shipToStateLabel: PropTypes.string,
    shipToZipCodeLabel: PropTypes.string,
    shipToCountryLabel: PropTypes.string,
};

export default ShippingFields;
